<template>
  <div class="composition-page">

    <chartLoaders v-if="showLoaders == true"></chartLoaders>
    <screen-loader v-if="showLoaders == true"></screen-loader>

    <v-card-text class=" chart-table-wrap pa-0" v-else-if="hasVisibleComposition && showLoaders == false">
      <div class="chart-wrap" v-if="fluidComponentReference">

        <div v-for="(variable, index) in variables" :key="index" class="chart-column" :style="getChartColumnStyle(index)">
          <div class="modal-tab-div">
            <div class="tab-div">
              <p>Y Axis Scale:</p>
              <v-btn-toggle v-model="isYLog[variable]" class="axis-toggle setHeight" mandatory
                @update:modelValue="handleYScaleToggleChange(variable)">
                <v-btn :value="true" class="switch-btn" outlined>Log</v-btn>
                <v-btn :value="false" class="switch-btn" outlined>Linear</v-btn>
              </v-btn-toggle>
            </div>
          </div>
          <div class="chart-name-top">
            <h6>{{ getHeaderDisplayNameChartTitle(variable) }}</h6>
          </div>
          <div :ref="`chart-${index}`" class="main-chart">
          </div>

          <v-dialog v-model="isPreviewOpen[index]" class="multi-chart-preview-div dashboard-chart-preview composition">
            <v-card class="position-relative studio-card">
              <v-card-text>
                <div class="popup-top">
                  <div class="modal-tab-div">
                    <div class="tab-div">
                      <p>Y Axis Scale:</p>
                      <v-btn-toggle v-model="isModalYLog[index]" class="axis-toggle setHeight" mandatory
                        @update:modelValue="handleModalYScaleToggleChange(index)">
                        <v-btn :value="true" class="switch-btn" outlined>Log</v-btn>
                        <v-btn :value="false" class="switch-btn" outlined>Linear</v-btn>
                      </v-btn-toggle>
                    </div>
                  </div>
                  <div class="chart-name-top w-100">
                    <h6>{{ getHeaderDisplayNameChartTitle(variable) }}</h6>
                  </div>
                  <!-- <img :src="cross" alt="cross" @click="closeModal(index)" class="chart-preview-close-btn"> -->
                </div>
                <div :ref="`modal-chart-${index}`" class="modal-chart-container"></div>
              </v-card-text>
            </v-card>
          </v-dialog>
        </div>
      </div>
      <div v-else-if="!fluidComponentReference" class="text-center pt-1 pb-5">
        <h4>Charts couldn't be plotted as fluid component reference is not available in this test.</h4>
      </div>
      <div class="table-wrap">
        <div class="table-title-div" v-if="serverItems.length > 0">
          <p class="table-title">Residual Oil Compositions</p>
          <div class="csv-btn" @click="downloadTableCSV">
            <v-img class="pointer" :src="documentDownload" alt="csv download"></v-img>
          </div>
        </div>
        <v-data-table v-if="showHeaders() && serverItems.length > 0" :headers="visibleHeaders" :items="visibleItems"
          :total-items="totalItems" :items-per-page="itemsPerPage" :loading="loading" :search="search"
          :item-value="name" virtual-items fixed-header max-height="calc(100vh - 380px)">
          <template v-slot:headers>
            <tr class="main-header">
              <th v-for="(header, index) in visibleHeaders" :key="index" class="sticky-header">
                {{ header.displayLabel || header.name }}
              </th>
            </tr>
            <tr class="sub-header">
              <th v-for="(header, index) in visibleHeaders" :key="index">
                {{ getCompositionTableUnitDisplay(header) }}
              </th>
            </tr>
          </template>
          <template v-slot:body="{ items }">
            <tr v-for="(item, index) in items" :key="index">
              <td v-for="(header, index) in visibleHeaders" :key="index">
                <template v-if="showVariable(header.key)">
                  {{ displayValue(header.key, item[header.key]) }}
                </template>
              </td>
            </tr>
          </template>
          <template v-slot:body.append>
            <tr>
              <td v-for="(header, index) in visibleHeaders" :key="index">
                <template v-if="index === 0">Total</template>
                <template v-else>
                  <span v-if="header.key.includes('MassFraction') && toggleFraction">
                    {{ sums[header.key] ? truncateNumber(sums[header.key], 3) : "-" }}
                  </span>
                  <span v-if="header.key.includes('MoleFraction') && !toggleFraction">
                    {{ sums[header.key] ? truncateNumber(sums[header.key], 3) : "-" }}
                  </span>
                </template>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-card-text>
    <div v-else-if="!hasVisibleComposition && showLoaders == false" class="tabs-no-test-div">
      <h4>No data available.</h4>
    </div>
  </div>
</template>

<script>
import Plotly from "plotly.js-dist-min";
import ChartLoaders from "../../Loaders/ChartLoaders.vue";
import ScreenLoader from "../../Loaders/ScreenLoader.vue";
import axios from "axios";
import api from "../../../../axiosInterceptor";
import { getDisplayName, getSortOrder } from "../../../../utils/cache";
import { buildPvtPlotTrace, isPvtTestRoute, loadDlTestFromRoute } from "../../../../utils/pvtTestRoute";

import downloadIcon from '../../../../assets/Svg/Chart/csv_chart.svg';
import camIcon from '../../../../assets/Svg/camIcon.svg';
import Expand from "../../../../assets/Svg/Chart/expand-btn.svg";
import { mapGetters } from "vuex";
import {  chartGridColor , INDIVIDUAL_TEST_MARKER_SIZE } from "@/utils/chartTheme";
import { downloadPlotlyAsPng } from "@/utils/plotlyPngDownload";
import { getTenantPrefix } from "@/utils/tenant";
import {
  formatChartAxisLabelPlain,
  getCompositionTableUnitDisplay,
  getPlotlyAxisTitleText,
  resolveChartHeaderUnit,
  sanitizeChartExportFileName,
} from "@/utils/chartAxisUtils";
import {
  estimateRotatedCategoryBottomMargin,
  getCompositionChartColumnHeight,
  plotlyLogAxisTickConfig,
} from "@/utils/plotlyLogAxis";
export default {
  name: "OilCompData",
  components: {
    ChartLoaders,
    ScreenLoader
  },
  data: () => ({
    documentDownload: require("../../../../assets/Images/csv.svg"),
    cross: require("../../../../assets/Svg/Chart/chart-cross.svg"),
    itemsPerPage: 0,
    headers: [],
    serverItems: [],
    loading: true,
    totalItems: 0,
    variables: ["1", "2"],
    isPreviewOpen: Array().fill(false),
    chartData: Array().fill(null),
    cachedData: {},
    testID: "",
    testName: "",
    sampleID: "",
    saturationPressure: "",
    saturationPressure_UOM: "",
    testTemperature: "",
    testTemperature_UOM: "",
    toggleFraction: true,
    showLoaders: true,
    fluidComponentReference: false,
    yAxisScales: {},
    isYLog: {},
    modalYAxisScales: {},
    isModalYLog: {},
    dlTestHeaderResId: {},
    sums: {},
    chartColumnHeights: {},
  }),
  computed: {
    tenantId() {
      return getTenantPrefix() || "";
    },
    isPvtTest() {
      return isPvtTestRoute(this.$route);
    },
    hasVisibleComposition() {
      const needle = this.toggleFraction ? "MassFraction" : "MoleFraction";
      return (this.serverItems || []).some((item) =>
        Object.keys(item || {}).some((key) => {
          if (key.includes("_UOM") || !key.includes(needle)) {
            return false;
          }
          const value = item[key];
          if (value === null || value === undefined || value === "" || value === "-") {
            return false;
          }
          if (typeof value === "string" && !value.trim()) {
            return false;
          }
          return Number.isFinite(Number(value));
        })
      );
    },
    ...mapGetters("darkMode", ["isDarkMode"]),
    visibleHeaders() {
      const headers = [];
      this.headers.forEach((header) => {
        if (
          header.key === "fluidComponentReference" ||
          (this.toggleFraction == true &&
            header.key.includes("MassFraction")) ||
          (this.toggleFraction == false && header.key.includes("MoleFraction"))
        ) {
          headers.push(header);
        }
      });
      return headers;
    },

    visibleItems() {
      return this.serverItems.map((item) => {
        const newItem = {};
        Object.keys(item).forEach((key) => {
          if (
            key === "fluidComponentReference" ||
            (this.toggleFraction == true && key.includes("MassFraction")) ||
            (this.toggleFraction == false && key.includes("MoleFraction"))
          ) {
            newItem[key] = item[key];
          }
        });
        return newItem;
      });
    },
  },
  watch: {
    serverItems: {
      handler(newItems) {
        this.calculateSums(); // Call calculateSums when serverItems change
      },
      deep: true,
    },
    $route(to, from) {
      this.chartPlotted()
    },
    toggleFraction(newVal, oldVal) {
      this.chartPlotted();
      this.calculateSums();
    },
    isDarkMode() {
      this.chartPlotted();
    }
  },
  methods: {
    getChartColumnStyle(index) {
      const height = this.chartColumnHeights[index];
      return height ? { height: `${height}px` } : {};
    },
    truncateNumber(value, decimals) {
      const factor = Math.pow(10, decimals);
      const truncatedValue = Math.floor(value * factor) / factor;
      return truncatedValue.toFixed(decimals);
    },
    calculateSums() {
      const sums = {};

      this.visibleHeaders.forEach((header) => {
        if (header.key.includes("MassFraction") && this.toggleFraction) {
          sums[header.key] = this.serverItems.reduce((sum, item) => {
            return sum + (parseFloat(item[header.key]) || 0);
          }, 0);
        } else if (
          header.key.includes("MoleFraction") &&
          !this.toggleFraction
        ) {
          sums[header.key] = this.serverItems.reduce((sum, item) => {
            return sum + (parseFloat(item[header.key]) || 0);
          }, 0);
        }
      });

      this.sums = sums;
    },
    handleYScaleToggleChange(variable) {
      if (this.yAxisScales[variable] === undefined) {
        this.yAxisScales[variable] = 'linear';
      }

      this.yAxisScales[variable] = this.isYLog[variable] ? "log" : "linear";

      const chartIndex = this.variables.indexOf(variable);

      this.modalYAxisScales[chartIndex] = this.yAxisScales[variable];
      if (this.modalYAxisScales[chartIndex] === "log") {
        this.isModalYLog[chartIndex] = true;
      }
      else {
        this.isModalYLog[chartIndex] = false;
      }
      if (this.cachedDlTest) {
        this.plotChartForVariable(variable, chartIndex, this.cachedDlTest);
      }
    },
    handleModalYScaleToggleChange(index) {
      if (this.modalYAxisScales[index] === undefined) {
        this.modalYAxisScales[index] = 'linear';
      }

      this.modalYAxisScales[index] = this.isModalYLog[index] ? "log" : "linear";

      this.plotModalChart(index)
    },
    toggleFractionFunction() {
      this.serverItems = [];
      if (this.loading == true && this.serverItems.length == 0) {
        this.showLoaders = true;
      }
      this.chartPlotted();
      this.$emit('toggle-fraction', this.toggleFraction);
    },
    showVariable(variable) {
      return (
        variable === "fluidComponentReference" ||
        (this.toggleFraction == true && variable.includes("MassFraction")) ||
        (this.toggleFraction == false && variable.includes("MoleFraction"))
      );
    },
    showHeaders() {
      return this.toggleFraction == true || this.toggleFraction == false;
    },

    plotCharts(variablesToPlot, ccetest) {
      variablesToPlot.forEach((variable, index) => {
        this.plotChartForVariable(variable, index, ccetest);
      });
    },

    async loadItems() {
      this.loading = true;
      this.showLoaders = true;

      try {
        const result = await loadDlTestFromRoute(this.$route, (url) => api.get(url));
        if (!result.ok) {
          console.error(result.message);
          return;
        }

        this.cachedDlTest = result.dltest;
        this.serverItems = result.dltest?.dlResidComposition || [];

        if (!this.serverItems || this.serverItems.length === 0) {
          console.warn("No data available in serverItems.");
          this.variables = [];
          this.headers = [];
          return;
        }

        this.totalItems = this.serverItems.length;
        this.testID = result.dltest.ID;
        this.testName = result.dltest.name;
        this.sampleID = result.dltest.sampleID;
        this.fluidSampleID = result.dltest.fluidSampleID;
        this.saturationPressure = result.dltest.saturationPressure;
        this.saturationPressure_UOM = result.dltest.saturationPressure_UOM;
        this.testTemperature = result.dltest.testTemperature;
        this.testTemperature_UOM = result.dltest.testTemperature_UOM;
        this.dlTestHeaderResId = result.pageData?.dlTestResidComponentHeader;
        this.sendDataToParent();

          const sortByArray = this.toggleFraction ? 'sortByMass' : 'sortByMole';

          let sortByKeys = await getSortOrder("dltests", "dlTest_resid_component", this.toggleFraction ? "table_for_mass" : "table_for_mole");
          if (!sortByKeys || sortByKeys.length === 0) {
            sortByKeys = Object.keys(this.serverItems[0] || {}).filter(
              (key) => !key.includes("_UOM")
            ).map(
              (key) => key.charAt(0).toLowerCase() + key.slice(1)
            );
          }

          this.fluidComponentReference = this.serverItems.some(item => item.hasOwnProperty('fluidComponentReference'));

          const availableKeys = new Set(
            sortByKeys.filter((key) =>
              this.serverItems.some((item) => key in item)
            )
          );

          const allKeys = sortByKeys.filter((key) => availableKeys.has(key));

          this.variables = Array.from(allKeys).filter(
            (key) =>
              (key !== "fluidComponentReference" &&
                key !== "stepNumber" &&
                this.toggleFraction == true &&
                key.includes("MassFraction")) ||
              (this.toggleFraction == false && key.includes("MoleFraction"))
          );

          const allUniqueKeys = Array.from(allKeys);

          const displayNames = [];
          const digitsArray = [];
          const defaultUoms = [];

          await Promise.all(
            allUniqueKeys.map(async (key) => {
              const fullKey = `dlResidComposition${key}`; // Concatenate at start
              const capitalizedKey = fullKey.charAt(0) + fullKey.slice(1);
              const { displayName, digits, defaultUOM } = await getDisplayName("dltests", capitalizedKey);
              displayNames.push(displayName);
              digitsArray.push(digits);
              defaultUoms.push(defaultUOM);
            })
          );
          this.headers = Array.from(allKeys).map((key, index) => {
            const uom = this.serverItems.find((item) => item[key + "_UOM"]);
            const name = displayNames[index];
            const unit = resolveChartHeaderUnit(
              key,
              uom ? uom[key + "_UOM"] : null,
              defaultUoms[index]
            );
            const digits = digitsArray[index] || 0;
            const displayLabel = formatChartAxisLabelPlain(name, unit);
            return {
              key: key,
              name: name,
              unit: unit,
              displayLabel,
              digits: digits,
            };
          });
          this.calculateSums();
          return result.dltest;
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        this.loading = false;
        this.showLoaders = false;
      }
    },

    async plotChartForVariable(variable, chartIndex, dltest) {
      if (!dltest) {
        return;
      }

      const header = this.headers.find(header => header.key === variable);
      const digits = header ? header.digits : 0;

      const filteredComposition = dltest.dlResidComposition
        .filter(
          step =>
            step.fluidComponentReference !== 'H2' && // Exclude "H2"
            step.fluidComponentReference &&         // Ensure x is valid
            step[variable] !== undefined &&         // Ensure y is not undefined
            step[variable] !== null                 // Ensure y is not null
        );

      const fluidComponents = filteredComposition.map(step => step.fluidComponentReference);
      const axisType = this.yAxisScales[variable] || "linear";
      const values = filteredComposition.map((step) => {
        const numericValue = Number(step[variable]);
        if (!Number.isFinite(numericValue)) {
          return null;
        }
        if (axisType === "log" && numericValue <= 0) {
          return null;
        }
        return numericValue;
      });
      this.chartColumnHeights[chartIndex] = getCompositionChartColumnHeight(fluidComponents);
      const logTickConfig = axisType === "log" ? plotlyLogAxisTickConfig() : {};
      const bottomMargin = estimateRotatedCategoryBottomMargin(fluidComponents);

      let trace = {
        x: fluidComponents,
        y: values,
        type: "scatter",
        mode: "lines+markers",
        name: variable,
        line: {
          color: "#2199A8",
          width: 2
        },
        marker: {
          color: "#2199A8",
          size: INDIVIDUAL_TEST_MARKER_SIZE,
          line: {
            color: "#2199A8",
            width: 1
          }
        },
        connectgaps: false,
        hovertemplate: `%{x}<br>%{y:.${digits}f}<extra></extra>`,
      };
      if (this.isPvtTest) {
        trace = buildPvtPlotTrace(trace);
      }

      const yAxisLabel = this.getHeaderDisplayNameChartTitle(variable);

      const layout = {
        xaxis: {
          title: {
            text: "Component",
            standoff: 8,
          },
          gridcolor: chartGridColor(this.isDarkMode),
          tickangle: -45,
          tickfont: {
            size: 10,
          },
          automargin: false,
        },
        yaxis: {
          title: {
            text: yAxisLabel,
            standoff: 20
          },
          type: axisType,
          ...logTickConfig,
          automargin: true,
          gridcolor: chartGridColor(this.isDarkMode),
        },
        margin: {
          l: 85,
          r: 0,
          b: bottomMargin,
        },
      };
      const config = {
        responsive: true,
        displaylogo: false,
        displayModeBar: true,
        modeBarButtonsToRemove: ['lasso2d', 'select2d', 'pan2d', "resetscale", "zoom", "toImage"],
        modeBarButtonsToAdd: [
          {
            name: "Expand",
            icon: {
              svg: `
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <image href="${Expand}" width="24" height="24"/>
                </svg>
              `,
            },
            click: this.openModal.bind(this, chartIndex),
          },
          {
            name: 'Download CSV',
            icon: {
              svg: `
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <image href="${downloadIcon}" width="24" height="24"/>
                </svg>
              `,
            },
            click: this.handleDownloadCSV.bind(this, chartIndex)
          },
          {
            name: "Download plot as a png",
            icon: {
              svg: `
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <image href="${camIcon}" width="24" height="24"/>
                </svg>
              `,
            },
            click: this.handleDownloadPNG.bind(this, chartIndex),
          },
        ],
      };

      this.chartData[chartIndex] = {
        trace: trace,
        layout: layout,
        config: config,
        yAxisLabel,
        xAxisLabel: "Component",
      };

      const chartRef = this.$refs["chart-" + chartIndex];
      if (chartRef && chartRef.length > 0) {
        const chartElement = chartRef[0];
        await this.$nextTick();
        Plotly.newPlot(chartElement, [trace], layout, config);
      } else {
        return
      }
    },
    getHeaderDisplayName(variable) {
      return this.getHeaderDisplayNameChartTitle(variable);
    },
    getHeaderDisplayNameChartTitle(variable) {
      const header = this.headers.find(header => header.key === variable);
      if (header) {
        return header.displayLabel || formatChartAxisLabelPlain(header.name, header.unit);
      }
      return variable;
    },
    getCompositionTableUnitDisplay(header) {
      return getCompositionTableUnitDisplay(header);
    },
    displayValue(key, value) {
      const header = this.headers.find(header => header.key === key);
      const digits = header ? header.digits : 0; // Get digits from header

      if (value !== null && value !== undefined) {
        if (typeof value === 'string') {
          return value;
        } else {
          const numValue = Number(value);
          if (!isNaN(numValue)) {
            return digits > 0 ? numValue.toFixed(digits) : value;
          }
        }
      } else {
        return "-";
      }
    },

    handleDownloadCSV(chartIndex) {
      this.downloadChartCSV(chartIndex);
    },

    handleDownloadPNG(chartIndex) {
      this.downloadChartPNG(chartIndex);
    },

    downloadChartPNG(index) {
      const chartElement = this.$refs[`chart-${index}`];
      if (!chartElement?.[0]) return;
      const chartData = this.chartData[index];
      const yAxisLabel = chartData?.yAxisLabel
        || getPlotlyAxisTitleText(chartData?.layout?.yaxis?.title)
        || `Chart ${index}`;
      const xAxisLabel = chartData?.xAxisLabel
        || getPlotlyAxisTitleText(chartData?.layout?.xaxis?.title)
        || "Component";
      const fileName = `${sanitizeChartExportFileName(yAxisLabel)} vs ${sanitizeChartExportFileName(xAxisLabel)}`;
      downloadPlotlyAsPng([chartData.trace], chartData.layout, fileName, {
        isDarkMode: this.isDarkMode,
        title: fileName,
      });
    },

    downloadChartCSV(index) {
      const chartData = this.chartData[index];

      if (chartData) {
        const yAxisLabel = chartData.yAxisLabel
          || getPlotlyAxisTitleText(chartData.layout?.yaxis?.title)
          || "Chart";
        const xAxisLabel = chartData.xAxisLabel
          || getPlotlyAxisTitleText(chartData.layout?.xaxis?.title)
          || "Component";
        const fileName = `${sanitizeChartExportFileName(yAxisLabel)} vs ${sanitizeChartExportFileName(xAxisLabel)} data.csv`;

        const csvHeader = [
          xAxisLabel,
          yAxisLabel,
        ];

        const csvRows = chartData.trace.x.map((xValue, i) => [
          xValue,
          chartData.trace.y[i],
        ]);

        const csvContent = [
          csvHeader.join(","),
          ...csvRows.map((row) => row.join(",")),
        ].join("\n");

        const blob = new Blob([csvContent], {
          type: "text/csv;charset=utf-8;",
        });

        const link = document.createElement("a");
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", fileName); // Set filename
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          console.error(
            "Your browser does not support downloading files programmatically. Please try a different browser."
          );
        }
      }
    },

    openModal(index) {
      this.isPreviewOpen[index] = true;
      this.$nextTick(() => {
        this.plotModalChart(index);
      });
    },

    closeModal(index) {
      this.isPreviewOpen[index] = false;
    },
    plotModalChart(index) {
      const chartData = this.chartData[index];
      if (chartData) {
        const modalChartRef = this.$refs[`modal-chart-${index}`][0];
        const axisType = this.modalYAxisScales[index] || "linear";
        const modalLayout = { ...chartData.layout };
        const yaxis = {
          ...modalLayout.yaxis,
          type: axisType,
        };

        if (axisType === "log") {
          Object.assign(yaxis, plotlyLogAxisTickConfig());
        } else {
          delete yaxis.tickmode;
          delete yaxis.tickvals;
          delete yaxis.ticktext;
          delete yaxis.dtick;
          delete yaxis.minor;
          delete yaxis.showexponent;
        }

        modalLayout.yaxis = yaxis;

        Plotly.Plots.resize(modalChartRef);
        Plotly.newPlot(
          modalChartRef,
          [chartData.trace],
          modalLayout,
          chartData.config
        );
      }
    },
    async sendDataToParent() {
      const headerArray = [];

      for (const item of this.dlTestHeaderResId) {
        headerArray.push({
          key: item.key,
          displayName: item.key, // Using key as displayName since it's already formatted
          value: item.value,
          isRoot: true // All items are root level in new structure
        });
      }

      const emitData = {
        headers: headerArray,
        dlTestHeader: this.dlTestHeaderResId
      };
      this.$emit("data-updated", emitData);
    },

    downloadTableCSV() {
      if (this.serverItems && this.serverItems.length > 0) {
        const fileName = `residual_oil_compositions_table.csv`;

        const csvHeader = this.headers.map((header) => header.displayLabel || header.name);
        const csvUnits = this.headers.map((header) => getCompositionTableUnitDisplay(header));

        const csvRows = this.serverItems.map((item) =>
          this.headers.map((header) => item[header.key])
        );

        const csvContent = [
          csvHeader.join(","),
          csvUnits.join(","),
          ...csvRows.map((row) => row.join(",")),
        ].join("\n");

        const blob = new Blob([csvContent], {
          type: "text/csv;charset=utf-8;",
        });

        const link = document.createElement("a");
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", fileName); // Set filename
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          console.error(
            "Your browser does not support downloading files programmatically. Please try a different browser."
          );
        }
      } else {
        console.error("No data available in the table to download.");
      }
    },

    chartPlotted() {
      this.loadItems().then((ccetest) => {
        const variablesToPlot = [];
        if (this.toggleFraction == true) {
          variablesToPlot.push(
            "liquid_MassFraction",
            "vapor_MassFraction",
            "overall_MassFraction",
          );
        }
        if (this.toggleFraction == false) {
          variablesToPlot.push(
            "liquid_MoleFraction",
            "vapor_MoleFraction",
            "overall_MoleFraction",
          );
        }

        if (
          JSON.stringify(variablesToPlot) !==
          JSON.stringify(this.variablesToPlot)
        ) {
          this.variablesToPlot = variablesToPlot; // Update the tracked variables to plot
          this.plotCharts(variablesToPlot, ccetest); // Plot charts only for the variables enabled by the toggle switches
        }

        variablesToPlot.forEach((variable, index) => {
          this.isYLog[variable] = false;
          this.isModalYLog[index] = false;
          this.plotChartForVariable(variable, index, ccetest);
        });
      });
    },
  },
  created() {
    if (this.isPvtTest) {
      this.toggleFraction = false;
    }
  },
  mounted() {
    this.chartPlotted();
  },
};
</script>